import { Navigate } from 'react-router-dom';
import { useApp } from '@/context/AppContext';

export default function ProtectedRoute({ children }) {
  const { userDetails, isInitialized } = useApp();

  // Wait for AppProvider to finish hydrating from localStorage before deciding.
  // On the first render userDetails is always null; without this guard we would
  // redirect to /login even when a valid persisted session exists (cold-start race).
  if (!isInitialized) {
    return null;
  }

  if (!userDetails) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
